import React from 'react';
import LitImage from '../../components/images/LitImage';

const SwitchToLitCard = ({ describe, img }) => {
  return (
    <>
      <div className='container'>
        <div className='switch-lit-container text-center'>
          <div className='switch-lit-img'>
            <LitImage
              image={img}
              alt="Icon"
              style={{ width: 'auto', height: '60px', margin: '0 auto'}}
              loading="lazy"
            />
          </div>
          <p>{describe}</p>
        </div>
      </div>
    </>
  )
}

export default SwitchToLitCard